import * as React from 'react'
import styled from 'styled-components'
import { sortBy } from 'lodash'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { agentService } from '../../../../core/services'
import * as interfaces from '../../../../static/interfaces'
import * as Hooks from '../../../../utils/hooks'
import { Button } from '../../../atoms'
import { EditTable } from '../../../organisms'
import AgentLayoutIndex from '../_layouts'
import SidebarLayout from 'components/pages/_layouts/sidebarLayout'

declare var window: interfaces.IWindow

interface IProps {
  posts: {
    posts: IJsonResponse
  }
  user: IJsonResponse
}

const COLUMNS = [
  {
    name: I18n.t('generic.id'),
    field: 'id',
    required: true,
  },
  {
    name: I18n.t('generic.name'),
    field: 'name',
    required: true,
  },
  {
    name: I18n.t('generic.related_posts'),
    renderElement: record => record.related_posts.map(post => post.name).join(),
    field: 'related_posts',
    required: false,
  },
]

const AgentRelatedPostsIndex: React.FC<IProps> = props => {
  Hooks.SetDocumentTitle(I18n.t('generic.related_posts'))
  const { data, pagination } = agentService.getDataFromJson(props.posts.posts)
  const [posts, setPosts] = React.useState(sortBy(data, 'related_posts'))
  const { data: user } = agentService.getDataFromJson(props.user)

  return (
    <SidebarLayout user={user} showSidebar={true}>
      <AgentLayoutIndex
        model="related_posts"
        hideAgentNav={true}
        title={
          <Heading>
            <span>{I18n.t('generic.related_posts')}</span>
            <Button small={true}>
              <a href="/agent/related_posts/new">{I18n.t('generic.create_new')}</a>
            </Button>
          </Heading>
        }
        main={
          <EditTable
            editable={true}
            columns={COLUMNS}
            records={posts}
            pagination={pagination}
            getEditLink={({ id }) => `/agent/posts/${id}/related_posts/edit`}
          />
        }
      />
    </SidebarLayout>
  )
}

const Heading = styled.div`
  .Button {
    margin-left: 12px;
  }
`

export default AgentRelatedPostsIndex
